<template>

    <span @click.alt.prevent.stop="openModal" v-html="labelName"></span>

</template>

<script>
export default {

    props: {

        labelKey: {
            type: String,
            default: ''
        },
        labelKey2: {
            type: String,
            default: ''
        },
        uppercase: {
            type: Boolean,
            default: true
        }


    },

    computed: {

        labelName() {

            return this.uppercase
                ? this.$t(this.labelKey.toUpperCase())
                : this.$t(this.labelKey);

            // return this.$t(this.labelKey.toUpperCase());

        }


    },

    methods: {

        openModal() {

            this.$store.commit('setModalHeader', this.labelKey2 != "" ? this.labelKey2.toUpperCase() : this.labelKey.toUpperCase() );
            this.$store.commit('showModal');

        }

    }
}

</script>
